export class LocaleModel {
  constructor(
    public localeName: string,
    public country: string,
    public selected?: boolean,
    public flag?: string
  ) {
    if (selected === undefined) selected = false;
  }
}
